import React, { useState, useEffect } from "react";
import {
  AnswerWrapper,
  UploadImageContainer,
  ShowImageContainer,
} from "./MultipleChoiceAnswerWithImageBlock.styled";
import UploadImage from "../UploadImage/UploadImage";
import { getFile } from "../../services/FileManager";

const MultipleChoiceAnswerWithImageBlock = ({
  arrIndex,
  textAnswers,
  type,
  setSelectedFile,
  dependency,
}) => {
  const [urlImage, setUrlImage] = useState("");
  const [nameImage, setNameImage] = useState("");
  const handleText = (e) => {
    if (type == "radio" && dependency) {
      dependency
        .filter(
          (f) =>
            f.dependentAnswer ===
            textAnswers[arrIndex].text + "-" + textAnswers[arrIndex].image
        )
        .map(
          (q) =>
            (q.dependentAnswer =
              e.target.value + "-" + textAnswers[arrIndex].image)
        );
    }
    textAnswers[arrIndex].text = e.target.value;
  };

  const handleImage = (type, item, urlPreviewImage) => {
    if (dependency) {
      dependency
        .filter(
          (f) =>
            f.dependentAnswer ===
            textAnswers[arrIndex].text + "-" + textAnswers[arrIndex].image
        )
        .map(
          (q) =>
            (q.dependentAnswer =
              textAnswers[arrIndex].text + "-" + (item ? item[0].name : ""))
        );
    }

    textAnswers[arrIndex].image = item ? item[0].name : "";
    setUrlImage(urlPreviewImage);
    setNameImage(textAnswers[arrIndex].image);
    setSelectedFile(item[0]);
  };

  useEffect(() => {
    if (textAnswers[arrIndex].image) {
      getFile(textAnswers[arrIndex].image).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setUrlImage(URL.createObjectURL(response));
        }
      });
    }
  }, [textAnswers]);

  return (
    <div>
      <AnswerWrapper className="answer-wrapper-multichoice">
        <input
          className={`answer-wrapper-multichoice-${type}`}
          type={type}
          name="answer"
        />
        <input
          type="text"
          placeholder={urlImage && urlImage !== "#" ? "" : "Type an answer"}
          defaultValue={textAnswers[arrIndex].text}
          onChange={(e) => handleText(e)}
        />
      </AnswerWrapper>
      <UploadImageContainer>
        <div id="contaierUpLoadImagenBlock">
          <UploadImage
            displayNameButton="Add Image"
            setFile={handleImage}
            nameFile={nameImage}
            withStyle={false}
          ></UploadImage>
        </div>
        {urlImage && urlImage !== "#" ? (
          <ShowImageContainer src={urlImage}></ShowImageContainer>
        ) : null}
      </UploadImageContainer>
    </div>
  );
};

export default MultipleChoiceAnswerWithImageBlock;
